import { Injectable } from '@angular/core';
import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';

@Injectable({
  	providedIn: 'root'
})
export class AnalyticsService {

	logEvent(eventName: string, eventParams?: Record<string, any>) {
		const analytics = getAnalytics();
		logEvent(analytics, eventName, eventParams);
	}
	  
	setUserId(userId: string) {
		const analytics = getAnalytics();
		setUserId(analytics, userId);
	}
	  
	setUserProperties(properties: Record<string, any>) {
		const analytics = getAnalytics();
		setUserProperties(analytics, properties);
	}
	  
	trackPageView(pagePath: string, pageTitle?: string) {
		this.logEvent('page_view', {
			page_path: pagePath,
			page_title: pageTitle || pagePath
		});
	}
}
